const GET_QLE_VERIFICATIONS_DATA: string = 'GET_QLE_VERIFICATIONS_DATA';
const SET_QLE_VERIFICATIONS_DATA: string = 'SET_QLE_VERIFICATIONS_DATA';
const OVERRIDE_DOCUMENT: string = 'OVERRIDE_DOCUMENT';

export const QLE_ACTION_TYPES = {
    GET_QLE_VERIFICATIONS_DATA,
    SET_QLE_VERIFICATIONS_DATA,
    OVERRIDE_DOCUMENT,
};